import React from 'react';
import { useParams } from 'react-router';
import { Container, Grid } from '@material-ui/core';
import DiscountPackageEdit from './components/DiscountPackageEditPage';
import ClientEditSidebar, { ACTIVE_CLIENT_SIDEBAR_TAB_NAMES } from '../clientedit/ClientEditSidebar';

function DiscountPackagePage() {
    const { clientId } = useParams();

    return (
        <Container fixed className="activity-edit page">
            <Grid className="pageWithSidebar">
                <ClientEditSidebar activeTab={ACTIVE_CLIENT_SIDEBAR_TAB_NAMES.discountpackages} />
                <Grid className="pageContent">
                    <DiscountPackageEdit clientId={clientId} />
                </Grid>
            </Grid>
        </Container>
    );
}

export default DiscountPackagePage;
